import { Modal, Row, Col } from "antd";
import { Flex, Box, Text } from "@chakra-ui/react";
import SelectUnidade from "components/Input/SelectUnidade";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import SelectContaCategoria from "components/Input/SelectContaCategoria";
import SelectContaBancaria from "components/Input/SelectContaBancaria";
import { MovimentacaoBancariaRequestParams } from "features/movimentacoes-bancarias/typings";
import SelectPessoas from "ui/components/Input/SelectPessoas";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import Toolbar from "components/Toolbar/index";
import { CloseModalButton } from "components/Button/CloseModalButton";
import FooterModal from "components/Button/FooterModal";
import { defaultFiltroMovimentacoesBancarias } from "./../../hooks/useFiltroMovimentacoesBancarias";
import { useState } from "react";
import SelectCentroDeCusto from "../../../../../../../../components/Input/SelectCentroDeCusto/index";

interface ModalFiltrosMovimentacaoBancariaProps {
  onClose: () => void;
  onSave: () => any;
  onReset: () => void;
  filtro: MovimentacaoBancariaRequestParams;
  visible: boolean;
  onChangeFiltro: (filtro: Partial<MovimentacaoBancariaRequestParams>) => void;
}

export default function ModalFiltrosMovimentacaoBancaria({
  onClose,
  visible,
  onChangeFiltro,
  onSave,
  onReset,
  filtro,
}: ModalFiltrosMovimentacaoBancariaProps) {
  const { tenant } = useCurrentTenant();
  const [localFiltro, setLocalFiltro] =
    useState<Partial<MovimentacaoBancariaRequestParams>>(filtro);
  const numeroFiltroSelecionados =
    (localFiltro.pessoaId?.length ? 1 : 0) +
    (localFiltro.unidadeId?.length ? 1 : 0) +
    (localFiltro.contasBancariasIds?.length ? 1 : 0) +
    (localFiltro.centrosDeCustoIds?.length ? 1 : 0) +
    (localFiltro.categoriasFinanceirasIds?.length ? 1 : 0);

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      width="700px"
      visible={visible}
      className="antd-custom-header"
      title={<Toolbar title="Filtros" onClose={onClose} border="0px" />}
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
              onClose();
            }}
            onClose={() => {
              onReset();
              setLocalFiltro(defaultFiltroMovimentacoesBancarias);
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText={`Filtrar ${
              typeof numeroFiltroSelecionados === "number" &&
              numeroFiltroSelecionados > 0
                ? ` (${numeroFiltroSelecionados})`
                : ""
            }`}
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
          />
        </Flex>
      }
    >
      <Box as={Row} gutter={16} mb={4}>
        <Col md={12}>
          <Text mb="2px" fontSize="13px">
            Unidade
          </Text>
          <SelectUnidade
            tenantId={tenant.id}
            onChange={(unidadeId) => {
              setLocalFiltro((state) => ({
                ...state,
                unidadeId,
                pessoaId: "",
              }));
            }}
            value={localFiltro.unidadeId}
          />
        </Col>

        <Col md={12}>
          <Text mb="2px" fontSize="13px">
            Devedor/Pagador
          </Text>
          <SelectPessoas
            tipoEntidades={[TipoEntidadeEnum.Condomino]}
            unidadeId={localFiltro.unidadeId}
            value={localFiltro.pessoaId}
            onChange={(pessoaId) => {
              setLocalFiltro((state) => ({ ...state, pessoaId }));
            }}
          />
        </Col>
      </Box>
      <Box as={Col} xs={24} mb={4}>
        <Text mb="2px" fontSize="13px">
          Conta Categoria
        </Text>
        <SelectContaCategoria
          multiple
          value={localFiltro.categoriasFinanceirasIds}
          placeholder="Todas as contas categorias"
          onChange={(categoriasFinanceirasIds) => {
            setLocalFiltro((state) => ({ ...state, categoriasFinanceirasIds }));
          }}
        />
      </Box>
      <Box as={Col} xs={24} mb={4}>
        <Text mb="2px" fontSize="13px">
          Conta Bancária
        </Text>
        <SelectContaBancaria
          mode="multiple"
          onChange={(contasBancariasIds) => {
            setLocalFiltro((state) => ({ ...state, contasBancariasIds }));
          }}
          value={localFiltro.contasBancariasIds}
          placeholder="Todas as contas bancárias"
        />
      </Box>

      <Box as={Col} xs={24} mb={4}>
        <Text mb="2px" fontSize="13px">
          Centro de Custo
        </Text>
        <SelectCentroDeCusto
          mode="multiple"
          onChange={(centrosDeCustoIds) => {
            setLocalFiltro((state) => ({ ...state, centrosDeCustoIds }));
          }}
          value={localFiltro.centrosDeCustoIds}
          placeholder="Todos os centros de custo"
        />
      </Box>
    </Modal>
  );
}
